const LV = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3csvg%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20513%20342'%3e%3crect%20y='0'%20fill='%23FFFFFF'%20width='513'%20height='342'/%3e%3cg%20fill='%23A2001D'%3e%3crect%20y='0'%20class='st1'%20width='513'%20height='127.6'/%3e%3crect%20x='0'%20y='214.4'%20class='st1'%20width='513'%20height='127.6'/%3e%3c/g%3e%3c/svg%3e";
export {
  LV as default
};
//# sourceMappingURL=LV.svg.es.js.map
